import SocialNetworkIcon from "./SocialNetworkIcon";




const Footer:React.FC = () => {
    return (
        <footer className="mx-auto  pb-[100px]  flex items-center justify-between
        flex-col mt-[50px] gap-4 w-[75%]
        sm:flex-row sm:mt-[150px] sm:gap-0 lg:w-[46%]
        ">
                                <div className="flex items-center justify-center gap-4
                w-full
                sm:w-[33%]
                ">
                    <SocialNetworkIcon iconClass="fa-brands fa-github" link="https://github.com/LearnLane-HQ"/>
                    <SocialNetworkIcon iconClass="fa-brands fa-instagram" link="https://www.instagram.com/learnlanehq/"/>
                    <SocialNetworkIcon iconClass="fa-brands fa-x-twitter" link="https://twitter.com/LearnlaneHq"/>
                </div>
                
        </footer>
    );
}
 
export default Footer;